"use client";

import { Toggle } from "@/components/form/Toggle";
import { Heading4 } from "@/components/text/Heading4";

export function HyperParameters({
  removeInstrumental,
  setRemoveInstrumental,
  removeBackgroundVocals,
  setRemoveBackgroundVocals,
  deReverbDeEcho,
  setDeReverbDeEcho,
  deNoise,
  setDeNoise,
  shouldShowLoadState,
}: {
  removeInstrumental: boolean;
  setRemoveInstrumental: (newRemoveInstrumental: boolean) => void;
  removeBackgroundVocals: boolean;
  setRemoveBackgroundVocals: (newRemoveBackgroundVocals: boolean) => void;
  deReverbDeEcho: boolean;
  setDeReverbDeEcho: (newDeReverbDeEcho: boolean) => void;
  deNoise: boolean;
  setDeNoise: (newDeNoise: boolean) => void;
  shouldShowLoadState: boolean;
}) {
  return (
    <div className="mt-10">
      <Heading4 elementType="h2" className="mb-4">
        Settings
      </Heading4>

      <Toggle
        toggled={removeInstrumental}
        setEnabled={setRemoveInstrumental}
        label="Remove instrumental"
        testId="remove-instrumental-toggle"
        className="mt-4"
        disabled={shouldShowLoadState}
      >
        Enable if your audio has instrumental
      </Toggle>
      <Toggle
        toggled={removeBackgroundVocals}
        setEnabled={setRemoveBackgroundVocals}
        label="Remove background vocals"
        testId="remove-background-vocals-toggle"
        className="mt-4"
        disabled={shouldShowLoadState}
      >
        Enable if your audio has background vocals.
      </Toggle>
      <Toggle
        toggled={deReverbDeEcho}
        setEnabled={setDeReverbDeEcho}
        label="Remove reverb and echo"
        testId="remove-reverb-and-echo-toggle"
        className="mt-4"
        disabled={shouldShowLoadState}
      >
        Enable if your audio has reverb or echo.
      </Toggle>
      <Toggle
        toggled={deNoise}
        setEnabled={setDeNoise}
        label="Remove noise"
        testId="remove-noise-toggle"
        className="mt-4"
        disabled={shouldShowLoadState}
      >
        Enable this to clean up your audio.
      </Toggle>
    </div>
  );
}
